import { useContext, useEffect } from 'react';
import { AppContext } from '../../../main/context/Provider';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AddButton } from '../../shared/components/AddButton';
import withFilteredQueryRequest from '../../shared/components/table/withFilteredRequest';
import EmployeeTable from '../components/EmployeeTable';

export const EmployeePage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const EmployeeList = withFilteredQueryRequest(
        'employees/employees-list',
        EmployeeTable
    );

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Empleados');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Empleados',
                route: Private_Routes.EMPLOYEE_PAGE,
            },
        ]);
    }, [lang]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div className='card-body'>
                        <div className='mb-3'>
                            <AddButton href={Private_Routes.CREATE_EMPLOYEE_PAGE} />
                        </div>
                        <EmployeeList />
                    </div>
                </div>
            </div>
        </div>
    );
};
